<template>
    <div class="ndp">
        <!-- Header -->
        <header class="ndp__header">
        <button class="ndp__back" @click="$router.back()" aria-label="Back">←</button>
        <h2 class="ndp__title">Detail</h2>
        <span class="ndp__spacer" />
        </header>

        <!-- Body -->
        <main class="ndp__body" v-if="item">
        <section class="ndp__card">
            <!-- Hero / banner -->
            <div class="ndp__hero">
            <div class="ndp__hero-inner">
                <h3 class="ndp__hero-title">{{ item.bannerTitle }}</h3>
                <span class="ndp__hero-chip">{{ item.bannerChip }}</span>
            </div>
            </div>

            <!-- Content -->
            <div class="ndp__content">
            <h3 class="ndp__content-title">{{ item.title }}</h3>

            <p class="ndp__p" v-for="(p, i) in item.paragraphs" :key="i">
                {{ p }}
            </p>

            <ul class="ndp__bullets">
                <li v-for="(b, i) in item.bullets" :key="i">
                <span class="ndp__tick">✅</span>
                <div class="ndp__bullet">
                    <div class="ndp__bullet-title">{{ b.title }}</div>
                    <div class="ndp__bullet-text">{{ b.text }}</div>
                </div>
                </li>
            </ul>

            <div class="ndp__time">{{ item.timeAgo }}</div>
            </div>
        </section>
        </main>

        <main class="ndp__body" v-else>
        <section class="ndp__empty">
            Notification not found.
        </section>
        </main>
    </div>
</template>

<script>
const MOCK_NOTIFICATIONS = [
    {
        id: '1',
        title: 'Try Our New Video Analysis Tool',
        bannerTitle: 'Video Analysis Tool for Product Reviews',
        bannerChip: 'Update',
        paragraphs: [
        `We’ve launched a brand-new Video Analysis Tool to improve your review quality and help you earn more rewards!`,
        ],
        bullets: [
        {
            title: 'Smart Feedback on Your Video Reviews',
            text:
            'Our tool automatically analyzes your review videos to ensure they’re clear, honest, and complete.',
        },
        {
            title: 'Increase Approval & Rewards',
            text:
            'Get suggestions to improve your review and increase your chances of getting full reward value (e-vouchers, discounts, etc.).',
        },
        {
            title: 'Faster Moderation',
            text:
            'Well-analyzed videos are processed faster, meaning quicker reward delivery!',
        },
        ],
        timeAgo: '34 Minutes ago',
    },
    {
        id: '2',
        title: 'Get Premium',
        bannerTitle: 'Premium Recommendations',
        bannerChip: 'Offer',
        paragraphs: [
        'Unlock personalized suggestions with our premium plan.',
        ],
        bullets: [
        { title: 'Tailored Content', text: 'See brands and topics matched to your style.' },
        { title: 'Priority Support', text: 'Faster responses and priority moderation.' },
        ],
        timeAgo: 'Today, 05:00 AM',
    },
    {
        id: '3',
        title: 'Daily Tip',
        bannerTitle: 'Daily Tip',
        bannerChip: 'Tip',
        paragraphs: [
        'Boost your profile visibility by adding a new video today.',
        ],
        bullets: [
        { title: 'Short & Clear', text: 'Keep reviews concise and on topic.' },
        { title: 'Lighting Matters', text: 'Record in a bright, quiet place.' },
        ],
        timeAgo: 'Just now',
    },
    ]

    export default {
        name: 'NotificationDetail',
        props: {
            id: { type: String, required: false },
        },
        data() {
            return {
            item: null,
            }
        },
        created() {
            // prefer prop first (because we set props:true in the route), else read from $route
            const id = this.id || this.$route.params.id
            this.item = MOCK_NOTIFICATIONS.find(n => n.id === String(id)) || null
        },
}
</script>

<style scoped>

.ndp { background:#fff; min-height:100vh; }

.ndp__header{
    display:grid;
    grid-template-columns:auto 1fr auto;
    align-items:center;
    padding:14px 16px;
}
.ndp__back{
    appearance:none; border:0; background:transparent;
    font-size:22px; line-height:1; padding:6px; cursor:pointer;
}
.ndp__title{ margin:0; text-align:center; font-weight:700; font-size:18px; color:#111; }
.ndp__spacer{ width:24px; }

.ndp__body{ padding:20px; }
.ndp__card{
    background:#fff;
    border-radius:16px;
    border:1px solid #eee;
    overflow:hidden;
    box-shadow:0 1px 0 rgba(0,0,0,.02);
    padding: 16px;
}

/* Banner */
.ndp__hero{
    background: linear-gradient(135deg,#8F7EF6 0%, #9D9AF8 100%);
    padding:16px;
    border-radius: 9px;
}
.ndp__hero-inner{
    background: rgba(255,255,255,0.12);
    border-radius:12px;
    padding:16px;
}
.ndp__hero-title{
    margin:0 0 8px; color:#fff; font-weight:700; font-size:16px;
}
.ndp__hero-chip{
    display:inline-block;
    /* background:#fff; color:#6C5CE7;
    padding:6px 10px; border-radius:10px; */
    font-weight:700; font-size:12px;
    color: #FFFFFF;
    font-weight: 500;
    font-size: 16px;
}

/* Content */
.ndp__content{ padding:16px; }
.ndp__content-title{ margin:0 0 10px; font-size:16px; font-weight:600; color:#111; }
.ndp__p{ margin:8px 0; color:#333; font-weight: 500; font-size: 12px; }

.ndp__bullets{ list-style:none; padding:0; margin:12px 0 0; }
.ndp__bullets li{
    display:flex; gap:10px; align-items:flex-start;
    padding:10px 0; border-bottom:1px solid #f0f0f0;
}
.ndp__bullets li:last-child{ border-bottom:0; }
.ndp__tick{ line-height:1.2; }
.ndp__bullet-title{ font-weight:400; color:#111; margin-bottom:4px; }
.ndp__bullet-text{ color:#444; }

.ndp__time{
    text-align:right; color:#9aa0a6; font-size:12px; margin-top:10px;
}

.ndp__empty{
    border:1px dashed #ddd;
    border-radius:12px;
    padding:24px;
    text-align:center;
    color:#666;
}

</style>
